(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Slidetoggle", [], factory);
	else if(typeof exports === 'object')
		exports["Slidetoggle"] = factory();
	else
		root["Slidetoggle"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition